import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, "Please enter a password that has at least 8 characters")
    .matches(/(?=.*?[0-9])(?=.*?[A-Z])/, "Must contain a capital and number")
    .required("This field is required"),
  confirmPassword: Yup.string()
    .oneOf(
      [Yup.ref("password"), ""],
      "Passwords do not match, please try again",
    )
    .required("This field is required"),
});

export default validationSchema;
